var React = require('react');

function IcAwsDnyamodbAttribute (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M0,19.255h19.255V0H0V19.255z M1.702,1.702h15.852v15.852H1.702V1.702z M20.745,0v19.255H40V0H20.745z\n\t M38.298,17.554H22.446V1.702h15.852V17.554z M0,40h19.255V20.745H0V40z M1.702,22.446h15.852v15.852H1.702V22.446z M20.745,40H40\n\tV20.745H20.745V40z M22.446,22.446h15.852v15.852H22.446V22.446z M9.624,3.191c-3.547,0-6.433,2.886-6.433,6.433\n\ts2.886,6.433,6.433,6.433s6.433-2.886,6.433-6.433S13.17,3.191,9.624,3.191z M9.624,14.355c-2.609,0-4.731-2.122-4.731-4.731\n\ts2.122-4.731,4.731-4.731s4.731,2.122,4.731,4.731S12.232,14.355,9.624,14.355z"}));
}

IcAwsDnyamodbAttribute.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsDnyamodbAttribute;

IcAwsDnyamodbAttribute.default = IcAwsDnyamodbAttribute;
